import { images } from 'assets'
import CustomInput from 'components/CustomInputs/CustomInput'
import CustomPlusMinusInput from 'components/CustomInputs/CustomPlusMinusInput'
import CustomTextArea from 'components/CustomInputs/CustomTextArea'
import styles from '../styles.module.scss'
import Select from 'react-select'
import classNames from 'classnames'
import CustomRadioGroup from 'components/CustomInputs/CustomRadioGroup'

const Medication = (props) => {
  const {
    index,
    remove,
    refillDisabled,
    arrayHelpers,
    templates = [],
    disableTemplates,
  } = props
  return (
    <div>
      <div className={styles.medTitle}>
        <div>Medication Number #{index + 1}</div>
        <button
          className={styles.imgBg}
          onClick={() => remove(index)}
          type="button"
        >
          <img src={images.close} className={styles.closeMed} alt="Close" />
          {/* <FontAwesomeIcon icon={faMinus} className={styles.closeMed} /> */}
        </button>
      </div>
      <div className={styles.medFormRoot}>
        {!disableTemplates &&
          arrayHelpers?.form?.values?.medications[index]?.warning && (
            <div className="d-flex align-items-end p-0">
              <div className="alert alert-warning mb-0" role="alert">
                <strong>Note:&nbsp;</strong>
                {arrayHelpers.form.values.medications[index].warning}
              </div>
            </div>
          )}

        {!disableTemplates && (
          <div className={styles.medicationInputParent}>
            {/*<span className={styles.medLabel}>Template :</span>*/}
            <Select
              className="w-100"
              placeholder="Medicine Template"
              options={[
                { label: 'None --', value: null },
                ...templates.map((template, index) => ({
                  label: template.name,
                  value: index,
                })),
              ]}
              onChange={(template) => {
                //   apply the template name to the current medication name
                if (template.value === null) {
                  arrayHelpers.replace(index, {
                    name: '',
                    composition: '',
                    route: '',
                    dosage: '',
                    frequency: '',
                    duration: '',
                    quantity: '',
                    refills: '',
                    instructions: '',
                    type: '',
                  })
                  return
                }
                arrayHelpers.replace(index, {
                  ...templates[template.value].medicine,
                })
              }}
            />
          </div>
        )}
        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Name:</span>
          {/* <Field name={`medications[${index}].name`} type="text" className={styles.MedicationInput} placeholder="Amoxicillin 30 mg" /> */}
          <CustomInput
            name={`medications[${index}].name`}
            type="text"
            className={styles.MedicationInput}
            placeholder="Amoxxillin 30 mg"
          />
        </div>
        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Composition:</span>
          {/* <Field name={`medications[${index}].composition`} type="text" className={styles.MedicationInput} placeholder="Tablet" /> */}
          <CustomInput
            name={`medications[${index}].composition`}
            type="text"
            className={styles.MedicationInput}
            placeholder="Tablet"
          />
        </div>
        {/* <div className={styles.medicationInputParent}><span className={styles.medLabel}>Route:</span>
                    <CustomSelect name={`medications[${index}].route`} className={styles.MedicationInput}>
                        <option value="" >Choose --</option>
                        <option value="oral">Oral</option>
                        <option value="injection">Injection</option>
                        <option value="topical">Topical</option>
                    </CustomSelect>
                </div> */}
        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Route:</span>
          {/* <Field name={`medications[${index}].name`} type="text" className={styles.MedicationInput} placeholder="Amoxxillin 30 mg" /> */}
          <CustomInput
            name={`medications[${index}].route`}
            type="text"
            className={styles.MedicationInput}
            placeholder="Oral"
          />
        </div>

        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Dosage:</span>
          {/* <Field name={`medications[${index}].dosage`} type="text" className={styles.MedicationInput} placeholder="1 Tablet" /> */}
          <CustomInput
            name={`medications[${index}].dosage`}
            type="text"
            className={styles.MedicationInput}
            placeholder="500 mg"
          />
        </div>
        {/* <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Frequency:</span>
          <CustomSelect
            name={`medications[${index}].frequency`}
            className={styles.MedicationInput}
          >
            <option value="">Choose --</option>
            <option value="Once a day">Once a day</option>
            <option value="Twice a day">Twice a day</option>
            <option value="Thrice a day">Thrice a day</option>
          </CustomSelect>
        </div> */}

        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Frequency:</span>
          {/* <Field name={`medications[${index}].name`} type="text" className={styles.MedicationInput} placeholder="Amoxxillin 30 mg" /> */}
          <CustomInput
            name={`medications[${index}].frequency`}
            type="text"
            className={styles.MedicationInput}
            placeholder="Twice a day"
          />
        </div>
        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Duration:</span>
          {/* <Field name={`medications[${index}].duration`} type="text" className={styles.MedicationInput} placeholder="3 days" /> */}
          <CustomInput
            name={`medications[${index}].duration`}
            type="text"
            className={styles.MedicationInput}
            placeholder="3 days"
          />
        </div>
        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Total Quantity:</span>
          {/* <Field name={`medications[${index}].quantity`} type="text" className={styles.MedicationInput} placeholder="30 tablets" /> */}
          <CustomInput
            name={`medications[${index}].quantity`}
            type="text"
            className={styles.MedicationInput}
            placeholder="30 tablets"
          />
        </div>
        {!refillDisabled && (
          <div className={styles.medicationInputParent}>
            <span className={styles.medLabel}>Refills:</span>
            {/* <Field name={`medications[${index}].refills`} type="text" className={styles.MedicationInput} placeholder="0" /> */}
            <CustomPlusMinusInput
              name={`medications[${index}].refills`}
              type="text"
              className={styles.MedicationInput}
              placeholder="0"
            />
          </div>
        )}
        <div className={styles.medicationInputParent}>
          <span className={styles.medLabel}>Instructions:</span>
          {/* <Field name={`medications[${index}].instructions`} component="textarea" className={styles.MedicationTextArea} /> */}
          <CustomTextArea
            name={`medications[${index}].instructions`}
            className={styles.MedicationTextArea}
            placeholder="Take with food"
            minHeight="30px"
          />
        </div>

        {disableTemplates && (
          <div className={styles.medicationInputParent}>
            <span className={styles.medLabel}>Warning:</span>
            {/* <Field name={`medications[${index}].instructions`} component="textarea" className={styles.MedicationTextArea} /> */}
            <CustomTextArea
              name={`medications[${index}].warning`}
              className={styles.MedicationTextArea}
              placeholder="Do not recommend if patient has any kidney issues.."
              minHeight="30px"
            />
          </div>
        )}
        <div>
          <div style={{ display: 'flex', gap: '34px' }}>
            <span className={styles.medLabel}>Medication Type:</span>
            <CustomRadioGroup
              name={`medications[${index}].type`}
              alignColumn
              options={[
                { value: 'acute', label: 'Acute' },
                { value: 'repeat', label: 'Repeat' },
                { value: 'variable', label: 'Variable' },
              ]}
            />
          </div>

          <hr />
        </div>
      </div>
    </div>
  )
}

export default Medication
